import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-services-section',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './services-section.component.html',
  styleUrl: './services-section.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ServicesSectionComponent {
  services = [
    {
      title: 'Fiber Broadband',
      description:
        'Stay connected with reliable internet from Cladded Glass Broadband.',
      image: '/images/service/bg1.png',
      icon: '/images/service/1.png',
    },
    {
      title: 'Telephone Service',
      description: 'Carrier grade landline telephone service.',
      image: '/images/service/bg2.png',
      icon: '/images/service/2.png',
    },
    {
      title: 'TV Service',
      description: 'Fast, no lag streaming from multiple providers.',
      image: '/images/service/bg4.png',
      icon: '/images/service/4.png',
    },
  ];
}
